import {ChangeDetectionStrategy, Component, forwardRef, input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'ms-label',
  templateUrl: './label.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LabelComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.marked]': 'required()',
    '[class.ms-field-text]': 'hostClass',
  },
})
export class LabelComponent implements ControlValueAccessor {
  readonly required = input(false);

  readonly hostClass = true;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnChange(_fn: any): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched(_fn: any): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setDisabledState(_isDisabled: boolean): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  writeValue(_obj: any): void {}
}
